import { AccessClient } from "./axiosInstance.js";

// 모든 교수에 대한 개략적인 정보 가져오기
export const loadAllAssessments = async () => {
  try {
    const response = await AccessClient.get("/api/assessments");
    //console.log("response : ", response);
    const {
      status,
      data: { data, message },
    } = response;
    return { status, data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;

    //console.log(status);
    //console.log(message);
    return { status, message };
  }
};

// 수행 평가에 대한 정보 가져오기
export const loadAssessment = async ({ id, studentId, teamName }) => {
  try {
    let url = `/api/assessments/${id}`;
    url = studentId ? url.concat("/student") : url;
    url = teamName ? url.concat("/team") : url;

    const response = await AccessClient.get(url, {
      params: {
        studentId,
        teamName,
      },
    });
    //console.log("response : ", response);

    const {
      status,
      data: { data, message },
    } = response;
    return { status, data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;

    console.log(status);
    console.log(message);

    return { status, message };
  }
};

// 수행평가 대한 정보 저장하기
export const saveAssessment = async ({ id, weekId, weekState, weekAuth }) => {
  console.log("saveAssessment => ", id, weekId, weekState, weekAuth);

  try {
    const response = await AccessClient.put(`/api/assessments/${id}`, {
      weekId,
      weekState,
      weekAuth,
    });
    const {
      status,
      data: { data, message },
    } = response;

    return { status, course: data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;
    return { status, message };
  }
};

// 개인 수행 평가에 저장하기
export const saveAssessmentStudent = async ({
  id,
  studentId,
  grade,
  memo,
  progress,
}) => {
  try {
    const response = await AccessClient.put(`/api/assessments/${id}/student`, {
      studentId,
      grade,
      memo,
      progress,
    });
    console.log("response : ", response);

    const {
      status,
      data: { data, message },
    } = response;
    return { status, data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;

    console.log(status);
    console.log(message);

    return { status, message };
  }
};

// 팀 수행 평가에 저장하기
export const saveAssessmentTeam = async ({
  id,
  teamName,
  grade,
  memo,
  progress,
}) => {
  try {
    const response = await AccessClient.put(`/api/assessments/${id}/team`, {
      teamName,
      grade,
      memo,
      progress,
    });
    console.log("response : ", response);

    const {
      status,
      data: { data, message },
    } = response;
    return { status, data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;

    console.log(status);
    console.log(message);

    return { status, message };
  }
};
